import { Link } from 'react-router-dom';

interface AdoptionButtonsProps {
  status: string;
  mainCategory: 'dog' | 'cat';
}

export function AdoptionButtons({ status, mainCategory }: AdoptionButtonsProps) {
  if (status !== 'available') {
    return (
      <div className="p-4 bg-accessible-red-600/10 text-accessible-red-600 rounded-lg text-center body-medium">
        {status === 'adopted' ? (
          'Ten zwierzak znalazł już nowy dom'
        ) : status === 'reserved' ? (
          'Ten zwierzak jest zarezerwowany'
        ) : (
          'Ten zwierzak nie jest przeznaczony do adopcji'
        )}
      </div>
    );
  }

  return (
    <div className="space-y-4">
      <Link to="/kontakt" className="w-full inline-flex items-center justify-center py-4 bg-accessible-red-600 hover:bg-accessible-red-700 text-white rounded-lg transition-colors btn-text-large">
        Chcę adoptować
      </Link>
      <Link to="/kontakt" className="w-full inline-flex items-center justify-center py-4 bg-accessible-gray-100 hover:bg-accessible-gray-200 dark:bg-accessible-gray-700 dark:hover:bg-accessible-gray-600 high-contrast:bg-white text-accessible-gray-700 dark:text-white high-contrast:text-black rounded-lg transition-colors btn-text-large">
        Zapytaj o {mainCategory === 'dog' ? 'psa' : 'kota'}
      </Link>
    </div>
  );
}